import { Plural } from "@lingui/react/macro"
import React from "react"
import { createPortal } from "react-dom"

import Paragraph from "../../../../../design-system/paragraph"
import * as analytics from "../../../../../utils/analytics"
import CatalogItemLocationModal from "../../../catalog-item-location-modal"
import { CatalogItem } from "../types"
import ClickableParagraph from "./clickable-paragraph"
import * as styles from "./index.module.scss"
import VendorCardImage from "./vendor-card-image"

type Props = CatalogItem & {
  style: React.CSSProperties
}

function CatalogTableRow({ style, ...catalogItem }: Props) {
  const { countries, currencyCodes, name } = catalogItem
  const [openModalType, setOpenModalType] = React.useState<
    "country" | "currency" | undefined
  >()

  const currenciesList = (
    <Plural
      value={currencyCodes.length}
      _0=""
      _1={currencyCodes[0]}
      one={currencyCodes[0]}
      other="# currencies"
      context="Catalog table: count of supported currencies"
    />
  )

  const trackCountriesClick = () => {
    analytics.buttonClicked({
      buttonName: `${name} countries`,
      buttonLocation: "body",
      buttonPosition: "1",
    })
  }

  const trackCurrenciesClick = () => {
    analytics.buttonClicked({
      buttonName: `${name} currencies`,
      buttonLocation: "body",
      buttonPosition: "1",
    })
  }

  return (
    <>
      {openModalType &&
        // Prevents the modal from being covered by filter elements on mobile
        createPortal(
          <CatalogItemLocationModal
            catalogItem={catalogItem}
            modalType={openModalType}
            onClose={() => setOpenModalType(undefined)}
          />,
          document.body,
        )}
      <li
        className={styles.container}
        style={style}
        data-testid="catalog-table-row"
      >
        <div className={styles.imageContainer}>
          <VendorCardImage {...catalogItem} />
        </div>
        <Paragraph variant="1" className={styles.name}>
          {name}
        </Paragraph>
        <div className={styles.countryCurrencyContainer}>
          <ClickableParagraph
            onClick={() => {
              trackCountriesClick()
              setOpenModalType("country")
            }}
            list={countries}
          >
            <Plural
              value={countries.length}
              _0=""
              _1={countries[0].label}
              one={countries[0].label}
              other="# countries"
              context="Catalog table: count of supported countries"
            />
          </ClickableParagraph>
        </div>
        <div className={styles.countryCurrencyContainer}>
          <ClickableParagraph
            onClick={() => {
              trackCurrenciesClick()
              setOpenModalType("currency")
            }}
            list={currencyCodes}
            tooltipContent={currenciesList}
          >
            {currenciesList}
          </ClickableParagraph>
        </div>
      </li>
    </>
  )
}

export default CatalogTableRow
